import React, { type FC } from 'react';

import { TimeSlot } from '../../../state/infiniteCalendarSeries';
import { SESSION_SIZE } from '../types';
import DiscountFooter from './DiscountFooter/DiscountFooter';
import SimpleTimeSlotList from './SimpleTimeSlotList/SimpleTimeSlotList';
import styles from './TimeSlotContainer.module.scss';
import { TimeSlotTabHeader } from './TimeSlotTabHeader/TimeSlotTabHeader';
import { useTab } from './useTab';

type TimeSlotContainerProps = {
    timeSlotData: TimeSlot[];
    timezone: string;
    locale: string;
    isAppRebrandActive: boolean;
    onTimeSelect: (sessionId: string, sessionLabel: string) => void;
};

export const TimeSlotContainer: FC<TimeSlotContainerProps> = ({
    timeSlotData,
    timezone,
    locale,
    onTimeSelect,
    isAppRebrandActive,
}) => {
    const { activeTab, setActiveTab, overallDiscount } = useTab(timeSlotData);

    return (
        <div
            className={styles.timeSlotContainer}
            data-testid="time-slot-container"
        >
            {timeSlotData.length < SESSION_SIZE ? (
                <SimpleTimeSlotList
                    onSessionClick={onTimeSelect}
                    sessions={timeSlotData}
                    timezone={timezone}
                    locale={locale}
                    isAppRebrandActive={isAppRebrandActive}
                />
            ) : (
                <TimeSlotTabHeader
                    sessions={timeSlotData}
                    onSessionClick={onTimeSelect}
                    timezone={timezone}
                    locale={locale}
                    activeTab={activeTab || ''}
                    setActiveTab={setActiveTab}
                    isAppRebrandActive={isAppRebrandActive}
                />
            )}
            {overallDiscount && (
                <DiscountFooter
                    discount={overallDiscount}
                    isAppRebrandActive={isAppRebrandActive}
                />
            )}
        </div>
    );
};
